import { FormItem } from "./FormItem";
import { useParameterTypesMap } from "../../hooks/useParameterTypesMap";

type ParametersProps = {
  parameters: Record<string, unknown>;
};

export const Parameters = ({ parameters }: ParametersProps) => {
  const { getParameterType } = useParameterTypesMap();

  return (
    <>
      {Object.entries(parameters)
        .filter(([key, value]) => key !== "$type")
        .map(([key, value]) => {
          return (
            <FormItem
              key={key}
              label={getParameterType(key)?.displayLabel ?? key}
              value={getParameterType(key)?.valueFormatter?.(value) ?? (value === null ? "" : String(value))}
            />
          );
        })}
    </>
  );
};
